import React, { Component } from 'react';
import { Layout, message }  from 'antd';
import Header               from 'Application/Header/Header';
import Content              from 'Application/Content/Content';
import Footer               from 'Application/Footer/Footer';
import { Sideboard }        from 'Application/Sideboard/Sideboard';

message.config({
    top: 50,
    duration: 5,
    maxCount: 5,
});

class App extends Component {

    render () {
        return (
            <Layout>
                <Sideboard />
                <Layout className="layoutWrapper" style={{ minHeight: '100vh' }}>
                    <Header />
                    <Content style={{ overflow: 'auto', flex: 1}}>
                        { this.props.children }
                    </Content>
                    <Footer />
                </Layout>
            </Layout>
        );
    }
}


export default App;
